import { cloneDeep, set } from "lodash";
import store from "../../../../../store";
import i18n from "../../../../../Utils/i18next/i18next";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { NotificationManager } from "react-notifications";
import { mergedDate } from "../../../../../Utils/ServiceUtils/ServiceUtils";

const { t } = i18n;

export const onSubmit = async (values, props) => {
  const { serviceReducer } = store.getState();
  const { updateTableRegistry, loadData, update, updateSingleRegistry, uuid } =
    props;
  const data = cloneDeep(values);

  // if (values?.contact?.value) set(data, "contact.uuid", values?.contact?.value);

  if (values?.requester?.value)
    set(data, "requester.uuid", values?.requester?.value);

  if (values?.offerType?.value)
    set(data, "offerType.uuid", values?.offerType?.value);

  if (values?.customerType?.value)
    set(data, "customerType.uuid", values?.customerType?.value);

  if (values?.expectedServiceTime) {
    set(
      data,
      "expectedServiceDateTime",
      mergedDate(values?.expectedServiceDateTime, values?.expectedServiceTime),
    );
  }

  if (values?.plannedServiceTime) {
    set(
      data,
      "plannedServiceDateTime",
      mergedDate(values?.plannedServiceDateTime, values?.plannedServiceTime),
    );
  }

  let payload;

  if (!update) {
    data.status = serviceReducer?.availableStatuses.find(
      (el) => !!el.isSelected,
    );

    const res = await GlobalAuthFetch({
      path: `/service`,
      method: "POST",
      data,
    });
    payload = res.payload;
  }

  if (update) {
    const res = await GlobalAuthFetch({
      path: `/service/${uuid}`,
      method: "PATCH",
      data,
    });
    payload = res.payload;
  }

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);

    return;
  }

  props.setErrorHeader(0, false);

  //Succes nofify
  loadData();
  NotificationManager.success(i18n.t("global:success"));
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();
  props.handleHide();
};

export const onValidate = (values, props) => {
  // const { update } = props;
  const errorsStep0 = {};
  const errorsStep1 = {};

  // if (!hasValue(values.tasksDictionary)) {
  //   errorsStep1.tasksDictionary = t("global:service.errors.tasksDictionary");
  // }

  // if (!values.contact) {
  //   errorsStep0.contact = t("global:offer.errors.contact");
  // }

  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }
  if (
    !!props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }

  if (
    !props.steps[1]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep1).length > 0
  ) {
    props.setErrorHeader(1, true);
  }
  if (
    !!props.steps[1]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep1).length <= 0
  ) {
    props.setErrorHeader(1, false);
  }

  return { ...errorsStep0, ...errorsStep1 };
};
